import type { IconComponent } from '@planner/icons';
import type { ReactNode } from 'react';
import * as styles from './empty-state.css';

export interface EmptyStateProps {
  title: ReactNode;
  description?: ReactNode;
  icon?: IconComponent;
  /** Usually one primary button, optionally a secondary one. */
  action?: ReactNode;
  /** Heading level that fits the surrounding document outline. */
  headingLevel?: 2 | 3 | 4;
}

/** Shown when a list or area has no content yet, with a way forward. */
export function EmptyState({
  title,
  description,
  icon: StateIcon,
  action,
  headingLevel = 2,
}: EmptyStateProps) {
  const Heading = `h${headingLevel}` as const;
  return (
    <div className={styles.root}>
      {StateIcon && (
        <span className={styles.icon}>
          <StateIcon size={24} />
        </span>
      )}
      <Heading className={styles.title}>{title}</Heading>
      {description && <p className={styles.description}>{description}</p>}
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
}
